import React from "react";
import "./style.scss";
import { IMAGES } from "src/shared/utils/appConstant";
import "bootstrap/dist/css/bootstrap.css";
import Footer from "src/components/footer";
import { Link } from "react-router-dom";
import { scrollToTop } from "src/shared/utils/appConstant";
import Button from "src/components/button";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css"; // Import the desired effect styles
import "animate.css";
import "animate.css/animate.min.css";
import { AnimationOnScroll } from "react-animation-on-scroll";
import { pageRoutes } from "src/shared/utils/pageRoutes.constant";

const Leadership = () => {
  return (
    <>
      <div className="leadership-container">
        <div className="leadership-image-container image-container position-rel">
          <div className="text-container">
            <h1 className="heading drop-in">Leadership</h1>
            <p className="heading-desc display-block display-none drop-in-2">
              Wingman Partners owes its success to the dynamic leadership that
              shapes our path. Our team, comprised of visionaries, strategists,
              and industry experts, is dedicated to pioneering innovation and
              upholding unwavering commitment to our clients. Introducing the
              individuals who drive our mission.
            </p>
          </div>
          <div className="breadcrumb position-abs drop-in-2">
            <Link to={pageRoutes.Home} onClick={scrollToTop}>
              Home
            </Link>
            <span className="breadcrumb-separator"> / </span>
            <p className="fw-light">
              <Link to={pageRoutes.Leadership}>Leadership</Link>
            </p>
          </div>
          <div className="red-bg-box"></div>
        </div>
        <div className="know-us-better">
          <div className="know-us-better-heading">
            <p>Get To Know Us Better</p>
          </div>
          <div className="content-container display-none">
            <div className="content-row-right">
              <div className="col-content animate__animated animate__fadeInLeft animate__delay-1s">
                <div className="col-heading">
                  <p>Ashav Kaushik</p>
                </div>
                <div className="col-subheading">
                  <p>CEO</p>
                  <div className="kub-icon">
                    <a
                      href="https://www.linkedin.com/in/ashavkaushik"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IMAGES.LINKDIN_ICON} alt=".." />
                    </a>
                  </div>
                </div>
                <div className="col-desc fs-24">
                  <p>
                    Meet  Ashav Kaushik, our visionary CEO and Founder of Wingman Partners, boasting diverse expertise in Application Software, Public Cloud, Embedded Software, and the Software Development Life Cycle. A skilled people manager with strong communication skills, he excels in Project Initiation, Product Definition, and Project Scheduling. From kernel to cloud, he navigates domains like Linux OS, embedded software, web, and mobility. Leading cross-functional teams, Ashav's innovation optimizes modules and delivers excellence in debugging. Beyond business, his interests in photography, gaming, and running showcase a well-rounded personality. Always abreast of market trends, he is a transformative leader in an ever-evolving tech landscape.{" "}
                  </p>
                </div>
              </div>
              <LazyLoadImage
                src={IMAGES.ASHAV_IMG}
                className="card-img-top animate__animated animate__fadeInRight animate__delay-1s"
                effect="blur"
                alt="ashav"
              />
            </div>
            <div className="content-row-left">
                <LazyLoadImage
                  src={IMAGES.NISHANT_IMG}
                  effect="blur"
                  alt="nishant"
                  className="animate__animated animate__fadeInLeft"
                />
              <AnimationOnScroll
                animateIn="animate__fadeInRight"
                offset={150}
                animateOnce={true}
              >
                <div className="col-content">
                  <div className="col-heading ">
                    <p>Nishant Kaushik</p>
                  </div>
                  <div className="col-subheading ">
                    <p>VP Engineering</p>
                    <div className="kub-icon">
                      <a
                        href="https://www.linkedin.com/in/nishant-kaushik-wingman-partners"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img src={IMAGES.LINKDIN_ICON} alt=".." />
                      </a>
                    </div>
                  </div>
                  <div className="col-desc">
                    <p>
                      Meet Nishant Kaushik, our Vice President Engineering, a
                      seasoned Technical Architect and Certified Scrum Master
                      with years of rich IT experience. Specializing in .NET,
                      AWS, and more, Nishant thrives on building high-quality,
                      scalable products. His diverse strengths include training,
                      Scrum mastery, and a keen focus on continuous improvement.
                      With a proven track record of successful relationships
                      with investors and senior management, Nishant is eager to
                      contribute his expertise to an organization's goals in
                      Information Technology. Connect with him for detailed
                      insights into his technical prowess and innovative
                      approach.
                    </p>
                  </div>
                </div>
              </AnimationOnScroll>
            </div>
          </div>
          <div className="kub-mv display-toggle kub-mv-display">
            <div className="kub-mv-display">
              <div className="kub-mv-content">
                <div className="kub-img-mv">
                  <img src={IMAGES.KUB_IMAGE_MV_1} alt="KUB-img" />
                </div>
                <div className="content-header-mv">
                  <div className="content-col">
                    <div className="content-name">
                      <p>Ashav Kaushik</p>
                    </div>
                    <div className="content-desg">
                      <p>CEO</p>
                    </div>
                  </div>
                  <div className="content-icon">
                    <a
                      href="https://www.linkedin.com/in/ashavkaushik"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IMAGES.LINKDIN_ICON} alt=".." />
                    </a>
                  </div>
                </div>
                <div className="content-para">
                  <p>
                  Meet  Ashav Kaushik, our visionary CEO and Founder of Wingman Partners, boasting diverse expertise in Application Software, Public Cloud, Embedded Software, and the Software Development Life Cycle. A skilled people manager with strong communication skills, he excels in Project Initiation, Product Definition, and Project Scheduling. From kernel to cloud, he navigates domains like Linux OS, embedded software, web, and mobility. Leading cross-functional teams, Ashav's innovation optimizes modules and delivers excellence in debugging. Beyond business, his interests in photography, gaming, and running showcase a well-rounded personality. Always abreast of market trends, he is a transformative leader in an ever-evolving tech landscape.{" "}
                  </p>
                </div>
              </div>
              <div className="kub-mv-content">
                <div className="kub-img-mv">
                  <img src={IMAGES.KUB_IMAGE_MV_2} alt="KUB-img" />
                </div>
                <div className="content-header-mv">
                  <div className="content-col">
                    <div className="content-name">
                      <p>Nishant Kaushik</p>
                    </div>
                    <div className="content-desg">
                      <p>VP Engineering</p>
                    </div>
                  </div>
                  <div className="content-icon">
                    <a
                      href="https://www.linkedin.com/in/nishant-kaushik-wingman-partners"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <img src={IMAGES.LINKDIN_ICON} alt=".." />
                    </a>
                  </div>
                </div>
                <div className="content-para">
                  <p>
                  Meet Nishant Kaushik, our Vice President Engineering, a seasoned Technical Architect and Certified Scrum Master with years of rich IT experience. Specializing in .NET, AWS, and more, Nishant thrives on building high-quality, scalable products. His diverse strengths include training, Scrum mastery, and a keen focus on continuous improvement. With a proven track record of successful relationships with investors and senior management, Nishant is eager to contribute his expertise to an organization's goals in Information Technology. Connect with him for detailed insights into his technical prowess and innovative approach. 
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="team">
          <div className="team-header fs-54">
            <p>Meet Our Team</p>
          </div>
          <div>
            <Link to="/team">
              <Button onClick={scrollToTop}>Team</Button>
            </Link>
          </div>
        </div>
        <div>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Leadership;
